document.documentElement.className = 'js';

// ELEMENTS
var levels = document.querySelectorAll('.level-item-input');
var placementResultFooter = document.querySelector('.results-footer.type-selection');
var levelSelectorItem = document.querySelectorAll('.level-selector .level-item');
var typeSelectorClose = document.querySelectorAll('.type-selector-close');
var typeInfoWrapper = document.querySelector('.type-info-wrapper');
var typeInfoContentDivs = document.querySelectorAll('.type-info-wrapper .type-info-content .info');
var typeNavItems = document.querySelectorAll('.type-info-wrapper .type-selector .nav .nav-item');
var typePopupTriggers = document.querySelectorAll('[data-popup]');
var typePopup = document.querySelector('.type-info-wrapper');
var typePopupCloser = document.querySelector('.type-info-wrapper .type-selector .close');
var emailForStatisticsTrigger = document.querySelector('.email-for-statistics-trigger');
var emailForStatisticsPopup = document.querySelector('.email-for-statistics-wrapper');
var emailErrorMsg = document.querySelector('.email-for-statistics .tipp.error');
var emailForm = document.querySelector('.email-input');
var emailFormInputs = document.querySelector('.email-input .form-inputs');
var occupationInputs = document.querySelectorAll('input[name="occupation"]');
var occupationInputsLabels = document.querySelectorAll('.occupation-input-label');
var formSuccessMsg = document.querySelector('.email-input .form-sent .message.success');
var formErrorMsg = document.querySelector('.email-input .form-sent .message.error');
var continueBtnWrapper = document.querySelector('.email-for-statistics-content .continue');
var continueBtn = document.querySelector('.email-for-statistics-content .continue .btn-continue');
var counterWrapper = document.querySelector('.email-for-statistics-content .continue .btn-continue .counter-wrapper');
var counterInner = document.querySelector('.email-for-statistics-content .continue .btn-continue .counter-wrapper .counter');
var simpleFillInTriggers = document.querySelectorAll('.fill-in-answer');
var sentenceFillInInput = document.querySelectorAll('.sentence-fill-in .fill-in-with-input');
var sentenceRewriteItem = document.querySelectorAll('.sentence-rewrite-item');
var exerciseContent = document.querySelector('.exercise-wrapper .exercise-content .exercise');
var sentenceSelectionTrigger = document.querySelectorAll('.fill-in.fill-in-selection');
var sentenceSelectionAnswers = document.querySelectorAll('.fill-in-answers .answers .answer-radio-label');
var letterInputs = document.querySelectorAll('.letter-input');
var eraseTriggers = document.querySelectorAll('.answer-placeholder .erase-trigger');
var slugInput = document.querySelector("input[name='slug']");

// FOR DISABLING SCRIPTS ON RESULT PAGES
var resultFooter = document.querySelector('.exercise-footer.result-footer');

// level selection
if (levels.length || placementResultFooter != null) {
    // radio input styles
    forEach(levelSelectorItem, function(index, elem) {
        elem.addEventListener('click', function() {
            forEach(levelSelectorItem, function(index, elem) {
                elem.classList.remove('checked');
            });
            elem.classList.add('checked');
        });
    });

    // uncheck
    forEach(typeSelectorClose, function(index, elem) {
        elem.addEventListener('click', function(e) {
            e.stopPropagation();
            var parentLevelSelectorItem = closest(elem, '.level-item');
            var parentLevelSelectorItemFor = parentLevelSelectorItem.htmlFor;
            var parentLevelSelectorInput = document.getElementById(parentLevelSelectorItemFor);
            if (parentLevelSelectorItem.classList.contains('checked')) {
                parentLevelSelectorItem.classList.remove('checked');
                parentLevelSelectorInput.checked = false;
            }
        });
    });


    // level type info
    // load popup with corresponding info
    forEach(typePopupTriggers, function(index, elem) {
        elem.addEventListener('click', function(e) {
            // putting stopPropagation here, to prevent any further events fired on 'level-item'
            e.stopPropagation();
            e.preventDefault();
            var targetTypeInfoSelector = elem.getAttribute('data-popup');
            var targetTypeInfo = document.querySelector('.' + targetTypeInfoSelector);
            var targetTypeNavItem = document.querySelector('[data-target=' + targetTypeInfoSelector + ']');
            typePopup.classList.add('open');
            targetTypeInfo.classList.add('active');
            targetTypeNavItem.classList.add('active');
        });
    });

    // closing popup
    typePopupCloser.addEventListener('click', function(e) {
        typePopup.classList.remove('open');
        // remove classes on close
        forEach(typeInfoContentDivs, function(index, elem) {
            elem.classList.remove('active');
        });
        forEach(typeNavItems, function(index, elem) {
            elem.classList.remove('active');
        });
    });
    // closing popup on ESC
    document.addEventListener('keyup', function(e) {
        if (e.keyCode == 27) {
            typePopup.classList.remove('open');
            // remove classes on close
            forEach(typeInfoContentDivs, function(index, elem) {
                elem.classList.remove('active');
            });
            forEach(typeNavItems, function(index, elem) {
                elem.classList.remove('active');
            });
        }
    });

    // changing when popup is already visible
    forEach(typeNavItems, function(index, elem) {
        elem.addEventListener('click', function(e) {

            // reset classes
            forEach(typeInfoContentDivs, function(index, elem) {
                elem.classList.remove('active');
            });
            forEach(typeNavItems, function(index, elem) {
                elem.classList.remove('active');
            });

            var targetTypeInfoContentDivClass = elem.getAttribute('data-target');
            var targetTypeInfoContentDiv = document.querySelector('.' + targetTypeInfoContentDivClass);

            elem.classList.add('active');
            targetTypeInfoContentDiv.classList.add('active');

        });
    });
}

// DURING TEST LOGIN POPUP
var loginPopupTrigger = document.querySelector('.login-popup-trigger');

if (loginPopupTrigger != null) {

    setTimeout(function(){

        loginPopupTrigger.classList.add('open');

    }, 2000);

    var loginForm = loginPopupTrigger.querySelector('.form');
    var errorWrapper = loginForm.querySelector('.errors');
    var errorText = errorWrapper.querySelector('.error-text');
    loginForm.addEventListener('submit', function(e) {

        e.preventDefault();

        errorWrapper.classList.remove('error');
        errorText.innerHTML = '';

        var xhr = new XMLHttpRequest();
        var formData = new FormData();
        var inputs = loginForm.querySelectorAll('input');

        inputs.forEach(function (input) {
            formData.append(input.name, input.value);
        })

        xhr.responseType = 'json';
        xhr.onreadystatechange = function() {

            if (xhr.readyState == XMLHttpRequest.DONE ) {

                if (xhr.status == 200) {

                    var loginStatus = xhr.response['status'];

                    if (loginStatus == 'ok') {
                        loginPopupTrigger.classList.remove('open');
                    } else {
                        errorWrapper.classList.add('error');
                        errorText.innerHTML = xhr.response['result']['email'];
                    }

                }
                else {
                    errorWrapper.classList.add('error');
                    errorText.innerHTML = 'Server error';
                }
            }
        };

        xhr.open("POST", loginForm.action, true);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send(formData);

    });

}

// email for statistics popup
// if (emailForStatisticsTrigger != null) {
//
//     var emailInput = document.getElementsByName('email')[0];
//     var nameInput =  document.getElementsByName('user_name')[0];
//
//     // countdown
//     var count = 10;
//
//     counterInner.innerHTML = count;
//
//     // FACEBOOK LOGIN
//     function statusChangeCallback(response) {
//         if (response.status === 'connected') {
//             getUserData();
//         }
//     }
//
//     function checkLoginState() {
//         FB.getLoginStatus(function(response) {
//             statusChangeCallback(response);
//         });
//     }
//
//     window.fbAsyncInit = function() {
//         FB.init({
//             appId            : '580458189010080',
//             autoLogAppEvents : true,
//             xfbml            : true,
//             version          : 'v2.9'
//         });
//
//         FB.getLoginStatus(function(response) {
//             statusChangeCallback(response);
//         });
//     };
//
//     (function(d, s, id) {
//         var js, fjs = d.getElementsByTagName(s)[0];
//         if (d.getElementById(id)) return;
//         js = d.createElement(s); js.id = id;
//         js.src = "//connect.facebook.net/hu_HU/sdk.js#xfbml=1&version=v2.9&appId=580458189010080";
//         fjs.parentNode.insertBefore(js, fjs);
//     }(document, 'script', 'facebook-jssdk'));
//
//     function getUserData() {
//         FB.api('/me', {fields: 'name, email'}, function(response) {
//             emailInput.value = response.email;
//             nameInput.value = response.name;
//         });
//     }
//
//     setTimeout(function(){
//
//         emailForStatisticsPopup.classList.add('open');
//
//         var counter = setInterval(timer, 1000);
//
//         function timer() {
//
//             count = count - 1;
//
//             if (count <= 0) {
//
//                 counterInner.innerHTML = count;
//                 clearInterval(counter);
//
//                 // enable button
//                 continueBtn.classList.remove('btn-gray');
//                 continueBtn.classList.add('btn-red');
//                 continueBtn.disabled = false;
//
//                 // counter-wrapper color
//                 counterWrapper.classList.add('count-ended');
//
//                 return;
//             }
//
//             counterInner.innerHTML = count;
//
//         }
//
//     }, 2000);
//
//     // storing email address
//     emailForm.addEventListener('submit', function(e) {
//
//         e.preventDefault();
//         var emailValue = emailInput.value;
//
//         if (testEmail(emailValue) && validateRadios(occupationInputs)) {
//
//             var url = emailForm.action;
//             var xhr = new XMLHttpRequest();
//             var formData = new FormData();
//             var tokenValue = document.querySelector('[name="_token"]').value;
//             var occupationValue = document.querySelector('[name="occupation"]:checked').value;
//             var name = nameInput.value;
//             formData.append('_token', tokenValue);
//             formData.append('email', emailValue);
//             formData.append('occupation', occupationValue);
//             formData.append('name', name);
//
//             xhr.onreadystatechange = function() {
//
//                 emailFormInputs.classList.add('processed');
//                 continueBtnWrapper.classList.add('hidden');
//
//                 setTimeout(function(){
//                     emailForStatisticsPopup.classList.remove('open');
//                 }, 3000);
//
//                 if (xhr.readyState == XMLHttpRequest.DONE ) {
//                     if (xhr.status == 200) {
//                         formSuccessMsg.classList.add('show');
//                     }
//                     else {
//                         formErrorMsg.classList.add('show');
//                     }
//                 }
//             };
//
//             xhr.open("POST", url, true);
//
//             xhr.send(formData);
//
//         }
//
//         if (!testEmail(emailValue)) {
//             emailInput.classList.add('invalid');
//             emailErrorMsg.classList.add('shown');
//         }
//
//         if (!validateRadios(occupationInputs)) {
//             forEach(occupationInputs, function(index, elem) {
//                 elem.closest('label').classList.add('invalid');
//             });
//         }
//
//     });
//
//     emailInput.addEventListener('focus', function () {
//         if (hasClass(emailInput, 'invalid')) {
//             emailInput.classList.remove('invalid');
//             emailErrorMsg.classList.remove('shown');
//         }
//     });
//
//     forEach(occupationInputs, function(index, elem) {
//         elem.addEventListener('change', function() {
//             forEach(occupationInputsLabels, function(index, elem) {
//                 elem.classList.remove('invalid')
//             });
//         });
//     });
//
//     continueBtn.addEventListener('click', function() {
//         if (!continueBtn.disabled) {
//             emailForStatisticsPopup.classList.remove('open');
//         }
//     });
//
// }

// simple fill in exercise
if (simpleFillInTriggers.length) {
    if (resultFooter == null) {
        forEach(simpleFillInTriggers, function(index, elem) {
            elem.addEventListener('click', function() {
                var fillInText = elem.innerHTML;
                var targetFillInItemNr = elem.getAttribute('data-target');
                var targetFillInItem = document.querySelector('.fill-in[data-fill-in-nr="' + targetFillInItemNr + '"]');
                targetFillInItem.innerHTML = fillInText;
            });
        });
    }
}

// sentence fill in item selection effect
if (sentenceFillInInput.length) {
    if (resultFooter == null) {

        forEach(sentenceFillInInput, function(index, elem) {
            elem.addEventListener('focus', function() {

                // remove active class on all other items
                forEach(sentenceRewriteItem, function(index, elem) {
                    elem.classList.remove('active');
                });

                // add active class on current item
                var parentItem = closest(elem, '.sentence-rewrite-item');
                parentItem.classList.add('active');

            });

            // remove active class from current item on blur
            elem.addEventListener('blur', function() {
                var parentItem = closest(elem, '.sentence-rewrite-item');
                parentItem.classList.remove('active');
            });
        });
    }
    // since items height will change on focus events, let's fix the wrapper's height on load
    exerciseContentHeight = getHeight(exerciseContent) + 50 + 'px';
    exerciseContent.style.height = exerciseContentHeight;
    // TODO set height on resize
}

// exercise type 6 letter fill-ins
if (letterInputs.length) {

    // variables for checking input
    var answerLetterItems = document.querySelectorAll('.answer-letter');
    var answerLetters = [];
    forEach(answerLetterItems, function(index, elem) {
        var letter = elem.getAttribute('data-default-value');
        answerLetters.push(letter);
    });
    var selectedLetters = [];

    forEach(letterInputs, function(index, elem) {
        elem.addEventListener('blur', function() {
            var value = elem.value.toUpperCase();

            // check if value is set AND is one of the available options AND has not been selected yet
            if (arrayContains(value, answerLetters) && value != '' && arrayContains(value, selectedLetters) == false && elem.disabled == false) {
                selectedLetters.push(value);
                // disable the input - erasing happens with click
                elem.disabled = true;
                // get content of selected answer
                var selectedAnswerLetterItem = document.querySelector('[data-default-value="' + value + '"]');
                var selectedAnswerParent = closest(selectedAnswerLetterItem, '.answer-label');
                var selectedAnswerText = selectedAnswerParent.querySelector('.answer').innerHTML;
                // put content into placeholder
                var currentLetterInputParent = closest(elem, '.label-with-number');
                var currentPlaceholder = currentLetterInputParent.querySelector('.answer-placeholder');
                var currentPlaceholderTextWrapper = currentPlaceholder.querySelector('.answer-placeholder-text');
                currentPlaceholderTextWrapper.innerHTML = selectedAnswerText;
                // set placeholder's class
                currentPlaceholder.classList.add('set');
                // put corresponding number into answer letter
                var currentNumber = elem.getAttribute('data-value');
                selectedAnswerLetterItem.innerHTML = currentNumber;
                // set answer's class
                selectedAnswerParent.classList.add('selected');
                // put value in hidden input
                currentHiddenInput = document.getElementById('input-#' + currentNumber + '#');
                currentHiddenInput.value = selectedAnswerText;
            } else {
                elem.value = '';
            }



        });
    });

    forEach(eraseTriggers, function(index, elem) {
        elem.addEventListener('click', function(event) {
            event = event || window.event;
            // erase text from placeholder
            var currentPlaceholder = closest(elem, '.answer-placeholder');
            var currentPlaceholderTextWrapper = currentPlaceholder.querySelector('.answer-placeholder-text');
            currentPlaceholderTextWrapper.innerHTML = '';
            // remove set class from placeholder
            currentPlaceholder.classList.remove('set');
            // reset answer label text and class
            var currentLetterInputParent = closest(currentPlaceholder, '.label-with-number');
            var currentLetterInput = currentLetterInputParent.querySelector('.letter-input');
            var currentAnswerLetter = currentLetterInput.value;
            var selectedAnswerLetterItem = document.querySelector('[data-default-value="' + currentAnswerLetter + '"]');
            var selectedAnswerParent = closest(selectedAnswerLetterItem, '.answer-label');
            selectedAnswerLetterItem.innerHTML = currentAnswerLetter;
            selectedAnswerParent.classList.remove('selected');
            // reset input and re-enable it
            currentLetterInput.disabled = false;
            currentLetterInput.value = '';
            currentLetterInput.focus();
            // remove current letter from selectedletters[]
            var currentAnswerLetterIndex = selectedLetters.indexOf(currentAnswerLetter);
            if (currentAnswerLetterIndex > -1) {
                selectedLetters.splice(currentAnswerLetterIndex, 1);
            }
            // reset hidden input's value
            var currentNumberWrapper = currentLetterInputParent.querySelector('.number');
            var currentNumber = currentNumberWrapper.innerHTML;
            var currentHiddenInput = document.getElementById('input-#' + currentNumber + '#');
            currentHiddenInput.value = '';
        });
    });

}

// ADMIN TITLE TO SLUG CONVERTER
if (slugInput != null) {

    var titleInput = document.querySelector("input[name='title']");

    titleInput.addEventListener('blur', function() {
        console.log('ize');

        var rawText = titleInput.value;
        var textWODiacritics = removeDiacritics(rawText);
        var textWOSpecChars = removeSpecChars(textWODiacritics);
        var textLowercase = textWOSpecChars.toLowerCase();
        var slug = textLowercase.replace(/ /g,"-");

        slugInput.value = slug;
    });

}
